import './App.css';
import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './Components/Home';
import Layout from './Components/Layout';
import Footer from './Components/Footer';
import About from './Components/About';
import HomeTwo from './Components/HomeTwo';
import Contact from './Components/Contact';
import Team from './Components/Team';
import Services from './Components/Services';
import ServiceDetailsa from './Components/ServiceDetailsa';
import BlogGrid from './Components/BlogGrid';
import BlogLeft from './Components/BlogLeft';
import BlogRight from './Components/BlogRight';
import BlogDetails from './Components/BlogDetails';


function App() {
  return (
    <>
      <BrowserRouter basename='/tm/react/dronyug'>
        <Layout/>
        <Routes>
          <Route path='/' element={<Home/>}></Route>
          <Route path='/about' element={<About/>}></Route>
          <Route path='/home-v2' element={<HomeTwo/>}></Route>
          <Route path='/contact' element={<Contact/>}></Route>
          <Route path='/team' element={<Team/>}></Route>
          <Route path='/services' element={<Services/>}></Route>
          <Route path='/service-details' element={<ServiceDetailsa/>}></Route>
          <Route path='/blog-grid' element={<BlogGrid/>}></Route>
          <Route path='/blog-grid-left' element={<BlogLeft/>}></Route>
          <Route path='/blog-grid-right' element={<BlogRight/>}></Route>
          <Route path='/blog-details' element={<BlogDetails/>}></Route>
        </Routes>
        <Footer/>
      </BrowserRouter>
    </>
  );
}

export default App;
